var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160,0H0v160h160V0z M128,128H32V32h96V128z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,0v160h160V0H352z M480,128h-96V32h96V128z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 64,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,512h160V352H0V512z M32,384h96v96H32V384z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 416,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 64,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256,128 288,128 288,96 320,96 320,64 224,64 224,32 192,32 192,64 192,80 192,96 256,96  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 128,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320,160 288,160 288,192 192,192 192,224 320,224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32,288 64,288 64,256 32,256 32,192 0,192 0,320 32,320  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192,320 256,320 256,288 224,288 224,256 160,256 160,192 128,192 128,256 96,256 96,320 128,320 128,288  144,288 160,288 192,288  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 256,
    width: 32,
    height: 64
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288,352 192,352 192,384 256,384 256,480 192,480 192,512 288,512 288,480 352,480 352,448 288,448  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 416,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 352,
    width: 32,
    height: 64
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480,416 384,416 384,512 416,512 416,448 480,448  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 480,
    width: 64,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 352,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384,384 416,384 416,288 352,288 352,320 384,320  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448,224 416,224 416,192 384,192 384,224 352,224 352,256 480,256 480,224 512,224 512,192 448,192  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 288,
    width: 64,
    height: 32
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.39b24c6ea22ba20180bcc73db0a54f2a.svg";
export { ForwardRef as ReactComponent };